import ShipmentList from "../components/shipments/ShipmentList.vue";

export default {
  ACCOUNTS: "Comptes",
  VIEW_ELIXIO_CONNECT: "Synchronisation",
  ADD_ELIXIO_CONNECT_SERVICE: "Ajouter un service",
  ADD_ELIXIO_CONNECT_CONFIGURE_THIS_SERVICE: "Configurer",
  ELIXIO_CONNECT_SUBMIT: "Soumettre",
  ELIXIO_CONNECT_TEST_CONFIG: "Configurations Test",
  ELIXIO_CONNECT_PROD_CONFIG: "Configurations Prod",
  ELIXIO_CONNECT_CONFIRM_THIS_SUBSCRIPTION: "Confirmer cette action?",
  ELIXIO_ADDITIONNAL_CONFIG_TITLE: "Configuration additionnelle",
  ELIXIO_START_CONNECT: "Lancer",
  ELIXIO_PENDING_CONNECT: "Mise à jour en cours ...",
  ELIXIO_STOP_CONNECT: "Arreter",
  ELIXIO_TAB_DATA_TITLE: "Synchroniser les données existantes",
  ELIXIO_TAB_CONFIG: "Configuration",
  ELIXIO_TAB_UPDATE_DATA: "Synchroniser les données existantes",
  ELIXIO_CONNECT_STATUS_PENDING: "En cours",
  ELIXIO_CONNECT_STATUS_DONE: "Terminé",
  ELIXIO_UPDATED_INVOICES: "Synchonisation des factures",
  ELIXIO_UPDATED_PAYMENTS: "Synchonisation des paiements",
  ELIXIO_UPDATED_CUSTOMERS: "Synchonisation des clients",
  ELIXIO_CONNECT_COMPLETED: "Synchronisation terminée",
  ELIXIO_CONNECT_CANCELLED: "Synchronisation annulée",
  ELIXIO_CONNECT_TOTAL_PROGRESS: "Progression totale",
  ELIXIO_START_IMPORT_AT: "Démarrer à partir de:",
  SELECT_DATE: "Sélectionner une date",
  ELIXIO_CONNECT_CONFIRM_THIS_DEACTIVATION: "Confirmer cette désactivation?",
  SOMETHING_WENT_WRONG: "Une erreur est survenue",
  ELIXIO_CONNECT_CONFIRM_THIS_REACTIVATION: "Confirmer cette réactivation?",
  OPERATION_SUCCEEDED: "Opération réussie",
  OPERATION_FAILED: "Opération échouée",
  LOGIN_TO_YOUR_ACCOUNT: "Connectez-vous à votre compte",
  MODULES: "Modules disponibles",
  LOGIN_TO: "Se connecter à",
  RE_LOGIN_TO: "Se reconnecter à",
  DEACTIVATE: "Désactiver",
  ACTIVATE: "Activer",
  REACTIVATE: "Réactiver",
  VALIDATE: "Valider",
  ACTIVE: "Actif",
  CONFIGURE: "Configurer",
  AUTH_FINISHED: "Authentification terminée. Rafraîchissement en cours...",
  NOT_CONFIGURED_YET: "Pas encore configuré",
  SHIPMENT_STATUS_DRAFT: "Brouillon",
  SHIPMENT_STATUS_ESTIMATED: "Estimée",
  SHIPMENT_STATUS_CREATED: "Créée",
  SHIPMENT_STATUS_PICKUP_CREATED: "Ramassage crée",
  SHIPMENT_STATUS_IN_TRANSIT: "En transit",
  SHIPMENT_STATUS_DELIVERED: "Livrée",
  SHIPMENT_STATUS_EXCEPTION: "Exception",
  SHIPMENT_STATUS_CANCELLED: "Annulée",
  Sender: "Expéditeur",
  ThirdParty: "Tiers",
  package: "Colis",
  envelope: "Enveloppe",
  "courier-pack": "Colis express",
  freight: "Fret",
  OutsideDoor: "Porte extérieure",
  FrontPorch: "Porche",
  Office: "Bureau",
  SideDoor: "Porte Latérale",
  Basement: "Sous-sol",
  FrontDesk: "Réceptioné",
  BetweenDoors: "Entre les portes",
  Security: "Sécurité",
  Counter: "Comptoir",
  Lobby: "Hall",
  Mailbox: "Boîte aux lettres",
  GateHouse: "Guérite",
  Desk: "Bureau",
  Kiosk: "Kiosque",
  Shipping: "Expédition",
  ProShop: "Boutique Pro",
  FrontDoor: "Porte d'entrée",
  Receiving: "Réception",
  Reception: "Accueil",
  BackDoor: "Porte arrière",
  Lab: "Laboratoire",
  MailRoom: "Salle de courrier",
  Garage: "Garage",
  Pharmacy: "Pharmacie",
  ServiceCounter: "Comptoir de service",
  PartsDepartment: "Département des pièces",
  lb: "Livres",
  kg: "Kilogrammes",
  EightFiveByEleven: "8.5 x 11",
  FourBySix: "4 x 6",
  SHIPMENTS_LIST: "Liste des expéditions",
  PER_PAGE: "Par page",
  PER_PAGE: "Par page",
  STATUS: "Statut",
  SEARCH: "Recherche",
  NUMERO: "N°",
  TYPE: "Type",
  DISPLAY_FROM_X_TO_X_OF_X_ENTRIES:
    "Affichage de {from} à {to} sur {of} entrées",
  X_LINES_SELECTED: "{count} lignes sélectionnées",
  SHIPMENT_CREATED_AT: "Créée le",
  SHIPMENT: "Expédition",
  SHIPMENT_STATUS: "Statut",
};
